// src/containers/reportBuilder/FinancialResultTable.jsx
//
// TAK-2086: the report's Financial Result appendix — the same table as the
// Documentation page's Financial Summary card (rows from
// utils/activity/financialSummary), styled like the report's other appendix
// tables. Inline styles, as with the other report-document tables in
// ReportPreview, so the Word export's DOM walk picks them up.

import { useTranslation } from 'react-i18next';
import { REPORT_FONT } from '../../components/reports/ReportTemplate';
import {
  financialSummaryHeadings,
  financialSummaryRows,
} from '../../utils/activity/financialSummary';

import './FinancialResultTable.scss';

const tableStyle = {
  width: '100%',
  maxWidth: 560,
  borderCollapse: 'collapse',
  fontSize: REPORT_FONT.body,
  fontFamily: 'Arial, sans-serif',
  marginTop: 6,
};

const thStyle = {
  padding: '5px 8px',
  fontSize: REPORT_FONT.th,
  color: '#6b7280',
  textTransform: 'uppercase',
  borderBottom: '1px solid #d1d5db',
};

const rowStyle = {
  // a linked activity's Program Contribution / Grant, set apart from the
  // line items below it (the extra space below it is in the .scss — the
  // global table styles override inline cell padding)
  program: { borderBottom: '1px solid #6b7280' },
  item: {},
  result: { fontWeight: 700, borderTop: '2px solid #6b7280' },
  note: { fontStyle: 'italic', color: '#6b7280' },
};

const FinancialResultTable = ({ summary }) => {
  const { t } = useTranslation();

  return (
    <table className="rb-financial-result" style={tableStyle}>
      <thead>
        <tr>
          <th style={{ ...thStyle, textAlign: 'left' }} />
          {financialSummaryHeadings({ summary, t }).map((heading) => (
            <th key={heading} style={{ ...thStyle, textAlign: 'right' }}>
              {heading}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {financialSummaryRows({ summary, t }).map((row) => (
          <tr
            key={row.key}
            className={
              row.kind === 'program'
                ? 'rb-financial-result__program'
                : undefined
            }
            style={rowStyle[row.kind]}
          >
            <td style={{ padding: '5px 8px' }}>{row.label}</td>
            {row.cells.map((cell, i) => (
              <td
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                style={{
                  padding: '5px 8px',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {cell.text}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default FinancialResultTable;
